import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';

import {
  ILongContractRequestsData,
  userPreferredTimeFormat,
} from '@pharmaplan/common';

import { ReactComponent as Calendar } from '../../../../assets/svg/calendar.svg';
import { getHoursDiff } from '../../../Modals/WorkshiftDetails/utils';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { getDayMonthDateYear } from '../../../Reports/helpers';
import ThemeConstants from '../../../../theme/ThemeConstants';
import { timeString } from '../../../../helpers/Functions';

import styles from './styles';
import strings from '../../../../localization';

interface IShiftsDistributionItem {
  totalShifts: Array<ILongContractRequestsData>;
}

const ShiftsDistributionItem: FC<IShiftsDistributionItem> = ({
  totalShifts,
}) => {
  const timeFormat = useAppSelector(userPreferredTimeFormat);

  return totalShifts.map((item) => {
    const { counterStart, counterEnd, startDate, endDate } = (item as {
        startDate: string;
        endDate: string;
        counterStart: string;
        counterEnd: string;
      }) ?? {};

    const date = getDayMonthDateYear(startDate);
    const hours = `${timeString(
      startDate,
      endDate,
      timeFormat,
    )} (${getHoursDiff(startDate, endDate)}${strings.hoursAbbreviation})`;

    let counterDate = null;
    let counterHours = null;

    if (counterStart && counterEnd) {
      counterDate = getDayMonthDateYear(counterStart);
      counterHours = `${timeString(
        counterStart,
        counterEnd,
        timeFormat,
      )} (${getHoursDiff(counterStart, counterEnd)}${strings.hoursAbbreviation})`;
    }

    return (
      <Box sx={styles.datesContainer}>
        <Box sx={styles.dateContainer}>
          <Calendar
            stroke={ThemeConstants.common.grey850}
            strokeWidth="1"
            height={16}
            width={15}
          />
          <Typography
            sx={[styles.text, counterStart ? styles.strikedDates : {}]}
          >
            {`${date} | ${hours}`}
          </Typography>
        </Box>

        {counterStart && (
          <Typography sx={[styles.text, styles.newDates]}>
            {`${counterDate} | ${counterHours}`}
          </Typography>
        )}
      </Box>
    );
  });
};
export default ShiftsDistributionItem;
